export default __webpack_public_path__ + "static/media/CTK.497bfa5e.png";